"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _ContactSupport = _interopRequireDefault(require("@material-ui/icons/ContactSupport"));

var _reactRouterDom = require("react-router-dom");

var _nicaLocatorCore = require("../../../nicaLocatorCore");

var _claimDialog = _interopRequireDefault(require("./claimDialog"));

var _feedbackDialog = _interopRequireDefault(require("../feedbackDialog"));

var _icUnverifiedLocationLarge = _interopRequireDefault(require("../../../../img/ic-unverified-location-large.svg"));

var _verified_white_24dp = _interopRequireDefault(require("../../../../img/verified_white_24dp.svg"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * TODO: Externalize this Api key !!!!!!
 */
var TitlePanel = function TitlePanel(_ref) {
  var location = _ref.location;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showClaimDialog = _useState2[0],
      setShowClaimDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showFeedbackDialog = _useState4[0],
      setShowFeedbackDialog = _useState4[1];

  var sliderRef = (0, _react.useRef)(null);
  var history = (0, _reactRouterDom.useHistory)();

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      logoWhite = _useContext.images.logoWhite,
      _useContext$flags = _useContext.flags,
      hideClaimLocation = _useContext$flags.hideClaimLocation,
      hideDetailsLogo = _useContext$flags.hideDetailsLogo,
      showCovidVerified = _useContext$flags.showCovidVerified;

  var photos = location ? location.photos : [];

  if (location && !photos.length) {
    if (!location.google_street_view_image) {
      var address = "".concat(location.address.line1, ", ").concat(location.address.city, ", ").concat(location.address.stateCode);
      var size = "640x640";
      var imageSrc = "https://maps.googleapis.com/maps/api/streetview?size=".concat(size, "&location=").concat(address, "&key=AIzaSyApSGBeZg_jMxvPCItA4b5JJdEvNcUqbyM");
      photos = [imageSrc];
    } else {
      photos = [location.google_street_view_image];
    }
  }

  var sliderSettings = {
    dots: true,
    arrows: false,
    className: "detail-photos-slider-inner",
    dotsClass: "sliderDots",
    autoplay: photos.length > 1,
    infinite: true,
    initialSlide: 0,
    autoplaySpeed: 5 * 1000
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h100 relative flex column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "detail-photos-slider"
  }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({}, sliderSettings, {
    ref: sliderRef
  }), photos.map(function (photo) {
    // console.log("PHOTO", "url('" + photo + "')");
    return /*#__PURE__*/_react.default.createElement("div", {
      key: photo
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        backgroundImage: "url('" + photo + "')",
        backgroundSize: "cover",
        width: "100%",
        height: "100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 50%"
      }
    }));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "detail-photos-slider-overlay"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "detail-icon-back-container"
  }, !hideDetailsLogo && /*#__PURE__*/_react.default.createElement("div", {
    className: "detail-knockout-logo"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://infusioncenter.org",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logoWhite,
    alt: "nica logo",
    style: {
      height: 35,
      width: 35
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "detail-back-button"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outlined",
    color: "default",
    onClick: function onClick() {
      return history.push('/');
    }
  }, "Back To Results"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "detail-location-name oswald flex column justify-content-center"
  }, location && location.covid_verified && showCovidVerified && /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight20"
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "This location's data has been verified by NICA",
    className: "pointer-events-all"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _verified_white_24dp.default,
    alt: "Verified"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pointer-events-none flex"
  }, location && location.name), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop10 pointer-events-all"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "default",
    onClick: function onClick() {
      return setShowFeedbackDialog(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_ContactSupport.default, {
    htmlColor: "#1c5c7f",
    className: "marginRight5"
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: "#1c5c7f"
    }
  }, "See info that needs an update?")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "detail-claim-container flex"
  }, location && !location.orgId && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "This location has not been claimed and verified by the owner."
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _icUnverifiedLocationLarge.default,
    alt: "unclaimed icon"
  }))), !hideClaimLocation && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center marginLeft30"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      return setShowClaimDialog(true);
    },
    disableElevation: true
  }, "Claim this location")))), /*#__PURE__*/_react.default.createElement(_claimDialog.default, {
    open: showClaimDialog,
    onClose: function onClose() {
      return setShowClaimDialog(false);
    },
    location: location
  }), /*#__PURE__*/_react.default.createElement(_feedbackDialog.default, {
    open: showFeedbackDialog,
    onClose: function onClose() {
      return setShowFeedbackDialog(false);
    },
    location: location
  }));
};

var _default = TitlePanel;
exports.default = _default;